import { render, staticRenderFns } from "./SocialLinks.vue?vue&type=template&id=5ab9b7d2&lang=pug&"
import script from "./SocialLinks.vue?vue&type=script&lang=js&"
export * from "./SocialLinks.vue?vue&type=script&lang=js&"
import style0 from "./SocialLinks.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ab9b7d2')) {
      api.createRecord('5ab9b7d2', component.options)
    } else {
      api.reload('5ab9b7d2', component.options)
    }
    module.hot.accept("./SocialLinks.vue?vue&type=template&id=5ab9b7d2&lang=pug&", function () {
      api.rerender('5ab9b7d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/sales-flow-ui/components/SocialLinks.vue"
export default component.exports